// extracted by mini-css-extract-plugin
export default {"container":"Edit_container__htxwg","card":"Edit_card__T08DE"};